import { useContext } from 'react';
import { CloseCallback, LoaderContext, OpenCallback } from './LoaderContext';

export const useLoader = (): [OpenCallback, CloseCallback] => {
  const { open, close } = useContext(LoaderContext);
  return [open, close];
};
